import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { SnackbarContent, useSnackbar } from 'notistack';
import React, { forwardRef, useCallback, useState } from 'react';

const UnauthorizedSnackbar = forwardRef(({ id, ...props }, ref) => {
     const { closeSnackbar } = useSnackbar();
     const [expanded, setExpanded] = useState(false);

     const handleExpandClick = useCallback(() => {
          setExpanded((oldExpanded) => !oldExpanded);
     }, []);

     const handleDismiss = useCallback(() => {
          closeSnackbar(id);
     }, [id, closeSnackbar]);

     function backendActionMessage(_props) {
          if (_props.error?.trace?.validating === 'Roles' || _props.error?.trace?.validating === 'Permissions') {
               if (_props.error?.trace?.rule === 'All' || _props.error?.trace?.rule === 'Any') {
                    return (
                         'The system tried to check if user has ' +
                         _props.error?.trace?.rule +
                         ' of the following ' +
                         _props.error?.trace?.validating +
                         ': ' +
                         _props.error?.trace?.items.join(', ')
                    );
               } else {
                    return (
                         'The system tried to check if user has a Permission with the Task "' +
                         _props.error?.trace?.items?.taskName +
                         '" on Resource: "' +
                         _props.error?.trace?.items?.resourceName +
                         '"'
                    );
               }
          } else if (_props.error?.trace?.validating === 'Resource Access') {
               return (
                    'The system tried to check if user has access to the following Resource: ' +
                    _props.error?.trace?.items
               );
          }
     }

     return (
          <SnackbarContent
               ref={ref}
               sx={{
                    minWidth: { sm: '344px !important' },
               }}
          >
               <Card sx={{ width: '100%', backgroundColor: '#FF6961' }}>
                    <CardActions
                         sx={{
                              padding: '8px 8px 8px 16px',
                              justifyContent: 'space-between',
                         }}
                    >
                         <Typography variant="body" sx={{ color: '#FFF' }}>
                              The user is not authorized to perform this action. See more details by expanding this
                              notification.
                         </Typography>
                         <div>
                              <IconButton
                                   aria-label="Show more"
                                   size="small"
                                   sx={{
                                        padding: '8px 8px',
                                        color: '#FFF',
                                        transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
                                        transition: 'all .2s',
                                   }}
                                   onClick={handleExpandClick}
                              >
                                   <ExpandMoreIcon />
                              </IconButton>
                              <IconButton
                                   size="small"
                                   sx={{ padding: '8px 8px', color: '#FFF' }}
                                   onClick={handleDismiss}
                              >
                                   <CloseIcon fontSize="small" />
                              </IconButton>
                         </div>
                    </CardActions>
                    <Collapse in={expanded} timeout="auto" unmountOnExit>
                         <Paper sx={{ backgroundColor: '#fff', padding: 2 }}>
                              <Typography gutterBottom variant="body" sx={{ color: '#000', display: 'block' }}>
                                   {backendActionMessage(props)}
                              </Typography>
                         </Paper>
                    </Collapse>
               </Card>
          </SnackbarContent>
     );
});

UnauthorizedSnackbar.displayName = 'UnauthorizedSnackbar';

export default UnauthorizedSnackbar;
